import {
  AsanSignActions,
  AsanSignActionTypes,
  AsanSignRequest,
  AsanSignResponse,
} from 'store/reducers/ibsigning/asansigning/sign/types'
import { Dispatch } from 'redux'
import { asanSigning } from '../../../../services/IbSigning/asan'

export const fetchAsanSignRequest = (): AsanSignActions => ({
  type: AsanSignActionTypes.FETCH_ASAN_SIGN_REQUEST,
})

export const fetchAsanSignFailed = (payload: any): AsanSignActions => ({
  type: AsanSignActionTypes.FETCH_ASAN_SIGN_FAILED,
  payload,
})

export const fetchAsanSignSuccess = (
  payload: AsanSignResponse
): AsanSignActions => ({
  type: AsanSignActionTypes.FETCH_ASAN_SIGN_SUCCESS,
  payload,
})

export const fetchAsanSign = (requestBody: AsanSignRequest) => {
  return async (dispatch: Dispatch<AsanSignActions>) => {
    dispatch(fetchAsanSignRequest())

    try {
      const data = await asanSigning(requestBody);
      dispatch(fetchAsanSignSuccess(data))
    } catch (error: any) {
      dispatch(fetchAsanSignFailed(error.message))
    }
  }
}
